module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "pz3-1"
    }
  }, [_vm._v("\n\t\t\t\t\tACKNOWLEDGMENTS ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz3-2"
    }
  }, [_vm._v("\n\t\t\t\t\tA great deal of gratitude goes to Michael Mitilier, director of the AIM Institute’s\n\t\t\t\t\tBusiness Academy of the Midlands, for initiating this informative series of books\n\t\t\t\t\tand for cornering me to be a contributor. My deep appreciation also goes to fellow\n\t\t\t\t\twriter Michael Kelly for offering his expertise, insightful comments and astute suggestions.\n\t\t\t\t\tAll the inspiring teachers who, from grade school through graduate school, imparted\n\t\t\t\t\tboth knowledge and wisdom must not be forgotten for their contributions. And finally,\n\t\t\t\t\tbut certainly not least, I thank my parents, who always encouraged a love of words,\n\t\t\t\t\tcuriosity about how languages work and a passion for sharing knowledge with others\n\t\t\t\t\tthrough teaching. Thank you all. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 63
// module chunks = 0